// @flow

import type { CampaignParams } from '../../types';
import type { HydrateFiltersAction } from '../../actions/filter';
import { HYDRATE_FILTERS } from '../../constants';
import { TYPE_CAMPAIGN } from '../../config';

export type CampaignParamsState = CampaignParams;

const initialState: CampaignParamsState = {};

const filter = (
  state: CampaignParamsState = initialState,
  action: HydrateFiltersAction,
): CampaignParamsState => {
  switch (action.type) {
    case HYDRATE_FILTERS:
      return action.payload[TYPE_CAMPAIGN];
    default:
      return state;
  }
};

export default filter;
